 
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { SActions } from './styles';
import UpdateApplicationButton from './UpdateApplicationButton';
import DeleteApplicationButton from '../DeleteApplicationButton';
import ApplicationStatus from 'core/enums/applicationStatus';
import { useApplicationById } from 'core/api/applications';
import { useModalStore } from 'stores/modal';
import MultiActionsButton from '../../MultiActionsButton';
import Add from 'images/icons/Add.svg?react';
import Button from 'components/Button';
import { DisabledField, ModalType } from 'core/useCases/modal/types';
import EventType from 'core/enums/eventType';

type ApplicationActionsProps = {
    applicationId: string;
};

const ApplicationActions: FC<ApplicationActionsProps> = ({ applicationId }) => {
    const application = useApplicationById(applicationId).data;
    const openModal = useModalStore((state) => state.openModal);
    const { t } = useTranslation();

    if (!application) {
        return null;
    }

    const openTaskModal = () => {
        openModal({
            defaultValues: {
                application,
            },
            disabledFields: [DisabledField.ApplicationId],
            title: t('task-list.add-task'),
            type: ModalType.Task,
        });
    };

    const openInterviewModal = () => {
        openModal({
            defaultValues: {
                application,
                type: EventType.Interview,
            },
            disabledFields: [DisabledField.ApplicationId],
            title: t('activities.add-interview'),
            type: ModalType.Event,
        });
    };
    return (
        <SActions>
            {[ApplicationStatus.New, ApplicationStatus.Engaged].includes(application.status) && (
                <MultiActionsButton parentButtonContent={<Add />} iconButton>
                    <Button onClick={openTaskModal} variant="popinText">
                        {t('contact-details.popin-button-task')}
                    </Button>
                    <Button onClick={openInterviewModal} variant="popinText">
                        {t('contact-details.popin-button-interview')}
                    </Button>
                </MultiActionsButton>
            )}
            <UpdateApplicationButton applicationId={applicationId} />
            <DeleteApplicationButton application={application} />
        </SActions>
    );
};

export default ApplicationActions;
